import React, { useEffect } from 'react';

export default function InstagramGrid() {
  useEffect(() => {
    // Memasukkan script Behold secara dinamis ke dalam head
    const script = document.createElement("script");
    script.type = "module";
    script.src = "https://w.behold.so/widget.js";
    document.head.append(script);

    // Cleanup script saat pindah halaman (opsional tapi bagus untuk performa)
    return () => {
      script.remove();
    };
  }, []);

  return (
    <section className="w-full min-h-screen snap-start flex flex-col justify-center px-6 md:px-12 lg:px-16 py-24 bg-white relative">
      <div className="max-w-[1280px] w-full mx-auto">
        
        {/* Header Tetap Menggunakan Style Buttersando */}
        <div className="mb-12 max-w-xl">
          <span className="font-butter-sans text-[12px] uppercase tracking-[0.2em] text-butter-muted mb-3 block">
            archive
          </span>
          <h2 className="font-butter-serif text-[36px] md:text-[44px] text-butter-text mb-4 leading-tight">
            recent work
          </h2>
          <p className="font-butter-sans text-[16px] md:text-[18px] text-butter-muted">
            portraits, visual notes, and selected moments worth keeping.
          </p>
        </div>

        {/* --- BEHOLD WIDGET --- */}
        {/* Widget akan otomatis mengisi ruang ini sesuai setting di dashboard Behold kamu */}
        <div className="w-full bg-white min-h-[400px]">
          <behold-widget feed-id="z5Sf9sGmBQZqnnFWgaQg"></behold-widget>
        </div>

        {/* View More CTA */}
        <div className="mt-16 flex justify-center md:justify-end">
          <a 
            href="https://instagram.com/buttersando" 
            target="_blank" 
            rel="noopener noreferrer"
            className="font-butter-sans text-[13px] md:text-[14px] uppercase tracking-widest text-butter-text border-b border-butter-line hover:border-butter-accent hover:text-butter-accent transition-colors pb-2 inline-flex items-center"
          >
            view more on instagram
          </a>
        </div>

      </div>
    </section>
  );
}